import { render, staticRenderFns } from "./VSpinner.vue?vue&type=template&id=2e6a893a"
import script from "./VSpinner.vue?vue&type=script&lang=js"
export * from "./VSpinner.vue?vue&type=script&lang=js"
import style0 from "./VSpinner.vue?vue&type=style&index=0&id=2e6a893a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports